module.exports = __webpack_public_path__ + "img/又拍云_logo.6bdb8361.png";